import * as FS from '@fullstory/browser';

/*
 * @param eventName The event name must be in PascalCase
 * @param eventProperties A dictionary with key-value pairs, The "keys" must be in camelCase.
 */
export function publishFSCustomEvent(
    eventName: string,
    eventProperties: { [key: string]: any }
  ) {
    try {
      FS.event(eventName, eventProperties);
    } catch (e) {
      console.log('Failed to publish fullstory custom event', e);
    }
  }
  
export const REGISTRATION_EVENT_PREFIX = 'Registration_';
const REGISTRATION_EVENT_PREFIX_REGEX = new RegExp(
  `(^${REGISTRATION_EVENT_PREFIX})`
);

export function publishEvent(
  eventName: string,
  eventProperties: { [key: string]: any }
) {
  eventName = eventName.replace(REGISTRATION_EVENT_PREFIX_REGEX, '').trim();
  publishFSCustomEvent(
    `${REGISTRATION_EVENT_PREFIX}${eventName}`,
    eventProperties
  );
}
